import { render } from "./TextArea.vue?vue&type=template&id=556f096c&ts=true"
import script from "./TextArea.vue?vue&type=script&lang=ts"
export * from "./TextArea.vue?vue&type=script&lang=ts"

import "./TextArea.vue?vue&type=style&index=0&id=556f096c&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__